<script setup lang="ts">
export interface GrammarTruncateProps {
  label?: string;
  ignoreExtension?: boolean;
  truncateEnd?: number;
}

const props = withDefaults(defineProps<GrammarTruncateProps>(), {
  label: '',
  ignoreExtension: false,
  truncateEnd: 3,
});
</script>

<template>
  <tpg-truncate v-bind="props" />
</template>
